import typography from '../fingo/typography';

const bchTypography = {
  ...typography,
  fontFamily: 'Nunito Sans',
  subNavItem: {
    fontWeight: '200',
    fontSize: 18,
    lineHeight: 1.1,
  },
};

export default bchTypography;
